import React from "react"
import Loader from "react-loader-spinner"
import { Link } from "react-router-dom"
import propTypes from "prop-types"

import { verifyEmail } from "../../../../services/authentication"
import Nav from "../../../../components/Nav"
import Logo from "../../../../components/Logo"
import configs from "../../../../configs"

class VerifyEmail extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      isVerified: false
    }
  }

  componentDidMount() {
    const {
      match: { params }
    } = this.props

    if (params.code) {
      verifyEmail(params.code).then(
        () => {
          this.setState({
            loading: false,
            isVerified: true
          })
        },
        () => {
          this.setState({
            loading: false,
            isVerified: false
          })
        }
      )
    }
  }

  render() {
    const { loading, isVerified } = this.state

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-7 authentication_sidebar">
            <Logo color="white" href="/" title="Resanec" />
            <Logo color="black" href="/" title="Resanec" mobile />

            <div className="authentication_sidebar_container">
              <h1 className="authentication_sidebar_title">
                NDIS Pre-Planning
              </h1>
              <div className="authentication_sidebar_subtitle">
                Online is easy. When done together, it’s better.
              </div>
              <div className="authentication_sidebar_description">
                <ul>
                  <li>Easy collaboration with family, friends</li>
                  <li>Efficient editing and revising capability</li>
                  <li>
                    Dynamic commenting facility to provide input and feedback on
                    pre-plan progress and is
                  </li>
                  <li>ideal if you live in a remote location....and more.</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-5 authentication_content authentication_content--dark">
            <Nav
              navigation={configs.authentication.navigation}
              className="nav--right nav--dark"
            />

            {loading ? (
              <Loader
                type="TailSpin"
                color="#0c4632"
                height={80}
                width={80}
                className="loader loader--flex"
              />
            ) : (
              <div className="authentication_content_container">
                {isVerified ? (
                  <>
                    <h2 className="authentication_content_title">
                      Email Verified
                    </h2>
                    <div className="authentication_content_description">
                      Please proceed to{" "}
                      <Link to="/sign-in">sign In to your account</Link>
                    </div>
                  </>
                ) : (
                  <>
                    <h2 className="authentication_content_title">
                      Unable to Verify Email
                    </h2>
                    <div className="authentication_content_description">
                      You can try{" "}
                      <Link to="/sign-in">sign in to your account</Link> or{" "}
                      <Link to="/forgot-password">reset your password</Link>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

VerifyEmail.propTypes = {
  match: propTypes.shape({
    params: propTypes.shape({
      code: propTypes.oneOfType([propTypes.number, propTypes.string])
    })
  }).isRequired,
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired
}

export default VerifyEmail
